const detectBrowser = () => {
  const userAgent = navigator.userAgent.toLowerCase();

  if (userAgent.includes('firefox'))
    return 'Firefox';
  if (userAgent.includes('chrome'))
    return 'Chrome';
  if (userAgent.includes('safari'))
    return 'Safari';
  if (userAgent.includes('opera') || userAgent.includes('opr'))
    return 'Opera';
  if (userAgent.includes('msie') || userAgent.includes('trident'))
    return 'Internet Explorer';

  return 'Unknown';
};

export default detectBrowser;